export const defaultFields = [
    'address',
    'city',
    'state',
    'zipcode',
    'status',
    'last_updated',
    'date_processed',
    'completion_date',
    'gas_rep_company_name',
    'gas_rep_representative',
    'gas_rep_city',
    'gas_rep_state',
    'appliance_total_incentives',
    'annual_source_emissions'
];

export const setDefaultValues = (defaultFields) => {
    const values = {};

    defaultFields.forEach(field => {
        values[field] = true;
    })

    return values;
}

export const validationPassed = (formData) => {
    const yearsValid = formData.applicableYears.length;
    const statusesValid = formData.projectStatuses.length;
    const fieldsValid = defaultFields.some(field => formData[field] === true);

    return Boolean(yearsValid && statusesValid && fieldsValid);
}
